// extracted by mini-css-extract-plugin
export var skipAnimation = "_42-0";